import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import hasPath from 'lodash/has';
import getPath from 'lodash/get';
import head from 'lodash/head';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { signinUser } from '../../actions/index';
import CreatePublisher from '../../components/create_publisher';
import { authManager } from '../../helpers/managers';
import { signInPassword, signInFacebook } from '../../shared_methods/common_auth';
import { addSoundcastToUser } from '../../shared_methods/add_soundcast_to_user';
import { handleChargeState } from '../../shared_methods/common_publisher';
import Colors from '../../styles/colors';
import { FullContentWrapper, FullContentSection } from '../../styles/styled';
import SignInForm from './SignInForm';
import FacebookTransition from './FacebookTransition';
import { addInvitedSoundcastsToUser } from '../../shared_methods/add_soundcast_to_user';
import { checkMonitoringUserSoundcastsManaged } from '../../helpers/userinfoHelper';

class AppSignin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: '',
      enterPublisherName: false,
      publisherName: '',
      loading: false,
      transitionUser: {},
      chargeState: JSON.parse(localStorage.getItem('chargeState')),
    };

    this.adminModes = ['admin'];
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onCreatePublisherName = this.onCreatePublisherName.bind(this);
    this.handleFBAuth = this.handleFBAuth.bind(this);
    this.onSignIn = this.onSignIn.bind(this);
    this.finalizeUserLogin = this.finalizeUserLogin.bind(this);
  }

  componentDidMount() {
    const { transition = false } = this.props;
    const locationState = this.getLocationState();
    if (hasPath(locationState, 'soundcast')) {
      const { soundcast, soundcastID, checked, sumTotal } = locationState;
      this.setState({
        soundcast,
        soundcastID,
        checked,
        sumTotal,
      });
    }

    // if where in transition page but required prop is not present
    // redirect the user to root page
    if (transition) {
      this.handleTransitionUser();
    }

    // reload page after sign out
    window.signinReload && window.location.replace('/signin');
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.location, nextProps.location)) {
      this.handleTransitionUser(nextProps);
    }
  }

  handleTransitionUser(props = {}) {
    props = !isEmpty(props) ? props : this.props;
    const { transition, history } = props;
    if (transition) {
      const locationState = this.getLocationState(props);
      if (!hasPath(locationState, 'transitionUser')) {
        return history.replace('/');
      }

      const { transitionUser } = locationState;
      this.setState({
        transitionUser,
      });
    }
  }

  getLocationState(props = {}) {
    const { history } = (isEmpty(props) ? this.props : props) || {};
    return getPath(history, 'location.state') || {};
  }

  async finalizeUserLogin(user) {
    try {
      const { chargeState } = this.state;
      const { signinUser } = this.props;

      if (isEmpty(user)) {
        throw new Error('User data is missing.');
      }

      // signin redux action
      signinUser(user);

      // check invitations
      await addInvitedSoundcastsToUser(user);

      // if state has soundcast, subscribe the user when logging in
      if (this.hasSoundcast()) {
        return this.continueSoundcastAccess(user);
      }

      // return to the page on which the login was called
      const { returnUrl } = this.getLocationState();
      if (!isEmpty(returnUrl)) {
        window.location.replace(returnUrl);
        return;
      }

      await checkMonitoringUserSoundcastsManaged(user);

      // if signing in as admin
      if (user.admin && !this.hasPathParamsId()) {
        window.location.replace('/dashboard/soundcasts');
        return;
      }

      // if signing in as invited admin (no longer valid)

      // if signing in as a listener, but a charge state was found
      // happens when a listener just purchase a plan to be an admin
      if (!user.publisherID && !isEmpty(chargeState)) {
        // converting listener account to admin case
        return this.setState({ userInfo: user, enterPublisherName: true });
      }

      window.location.href = '/mysoundcasts';
    } catch (err) {
      console.error(err.message);
      this.setState({ loading: false });
      this.showError(`There was a problem logging in. (${err.message})`);
    }
  }

  onSignIn() {
    const { email, password } = this.state;
    this.setState({ loading: true }, async () => {
      try {
        const user = await signInPassword(email, password);
        await this.finalizeUserLogin(user);
      } catch (err) {
        console.error(err.message);
        this.showError(err.message);
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  async onCreatePublisherName() {
    const { userInfo, chargeState, publisherName } = this.state;
    try {
      await handleChargeState(userInfo, chargeState, publisherName);
      localStorage.removeItem('chargeState');
    } catch (err) {
      return alert('There was a problem finalizing your publisher account, please notify support.');
    }

    window.location.replace('/dashboard/soundcasts');
  }

  async handleFBAuth() {
    const { history, match } = this.props;
    try {
      this.setState({ loading: true });
      const user = await signInFacebook();
      this.setState({ loading: false });
      console.log('Success signInFacebook', user);
      if (user && user.firstName) {
        const transitionUser = { ...user };
        history.push({ pathname: '/signin/transition' }, { transitionUser });
      } else {
        // logout the user first, because a session was created
        await new Promise(async resolve => {
          try {
            const user = authManager.getCurrentUser();
            if (!isEmpty(user)) {
              await authManager.signOut();
            }

            resolve();
          } catch (err) {
            console.log('Unable to signout user', err.message);
            resolve();
          }
        });

        const linkState = await new Promise(resolve => {
          let pathname = '/signup/admin';
          let state = { fromFBSignIn: true };

          if (this.hasSoundcast()) {
            state = { ...state, ...this.getLocationState() };
            pathname = `/signup/soundcast_user/${state.soundcastID}`;
          }

          if (this.isAdminMode() && this.hasPathParamsId()) {
            pathname = `/signup/admin/${match.params.id}`;
          }

          resolve({
            pathname,
            state,
          });
        });

        const error = (
          <span>
            You don’t have a Soundwise account. Please{' '}
            <ClickHere to={linkState}>click here</ClickHere> to signup for a soundcast to get
            started.
          </span>
        );

        this.showError(error);
      }
    } catch (error) {
      this.showError(error.message);
    }
  }

  handleInputChange(field) {
    return e => {
      this.setState({
        [field]: e.target.value,
        error: '',
      });
    };
  }

  showError(error) {
    this.setState({
      error,
      loading: false,
    });
  }

  isAdminMode() {
    return this.isCurrentMode(this.adminModes);
  }

  isCurrentMode(modes) {
    const { match } = this.props;
    if (!this.hasPathParamsMode()) {
      return false;
    }

    return modes.includes(match.params.mode);
  }

  hasPathParamsMode() {
    const { match } = this.props;
    return hasPath(match, 'params.mode');
  }

  hasPathParamsId() {
    const { match } = this.props;
    return hasPath(match, 'params.id');
  }

  hasSoundcast() {
    const { soundcast } = this.state;
    return !isEmpty(soundcast);
  }

  continueSoundcastAccess(user) {
    const { history } = this.props;
    const { soundcastID, soundcast, checked, sumTotal } = history.location.state;
    if (this.hasSoundcast()) {
      const totalPrice = hasPath(soundcast, `prices.${checked}.price`)
        ? Number(soundcast.prices[checked].price)
        : 0;

      addSoundcastToUser(
        null,
        user,
        soundcastID,
        soundcast,
        checked,
        sumTotal,
        null,
        totalPrice,
        state => history.push({ pathname: '/notice', state })
      );
    } else {
      history.push('/soundcast_checkout', {
        soundcastID,
        soundcast,
        checked,
        sumTotal,
        userInfo: user,
      });
    }
  }

  renderImageUrlNode() {
    const { soundcast } = this.state;
    const alt = this.hasSoundcast() ? 'Soundcast Cover Art' : 'Soundwise Logo';
    const src = this.hasSoundcast() ? soundcast.imageURL : '/images/SOUNDWISE_LOGO_BLACK.png';

    return (
      <LogoImgWrapper>
        <img alt={alt} src={src} />
      </LogoImgWrapper>
    );
  }

  renderFormBody() {
    const { history } = this.props;
    const {
      email,
      password,
      error,
      enterPublisherName,
      publisherName,
      loading,
      transitionUser,
    } = this.state;
    const { location = {} } = history;

    // render publisher creation if set
    if (enterPublisherName) {
      return (
        <CreatePublisher
          onNameChange={this.handleInputChange('publisherName')}
          name={publisherName}
          onCreate={this.onCreatePublisherName}
          loading={loading}
        />
      );
    }

    // render facebook to email/pass transition if set
    if (!isEmpty(transitionUser)) {
      const { email = [] } = transitionUser;
      const firebaseEmail = head(email);
      return (
        <FacebookTransition
          email={firebaseEmail}
          onTransitionSuccess={() => {
            this.finalizeUserLogin(transitionUser);
          }}
        />
      );
    }

    // const header = (location.state && location.state.text) || 'Hello!';
    const header = 'Sign in to your account';
    return (
      <SignInForm
        header={header}
        email={email}
        password={password}
        onInputChange={this.handleInputChange}
        onUseFacebook={this.handleFBAuth}
        onSignIn={this.onSignIn}
        processing={loading}
        error={error}
      />
    );
  }

  renderSoundcastColumn() {
    const { soundcast } = this.state;

    if (isEmpty(soundcast)) {
      return null;
    }

    const { features = [] } = soundcast;

    return (
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div className="padding-five">
          <div
            className="margin-twenty-one-top sm-margin-nineteen-top title-medium text-dark-gray"
            style={{ paddingBottom: 35, textAlign: 'center' }}>
            <span>{soundcast.title}</span>
          </div>
          <div
            style={{ marginBottom: 20, fontSize: 15 }}
            className="text-large text-center text-dark-gray">
            {soundcast.short_description}
          </div>
          <ul className="" style={{ paddingBottom: '1em', display: 'flex', flexWrap: 'wrap' }}>
            {features.map((feature, i) => {
              if (isEmpty(feature)) {
                return null;
              }

              return (
                <li
                  key={i}
                  className=" text-dark-gray text-large  margin-lr-auto col-md-12 col-sm-12 col-xs-12 tz-text"
                  style={{
                    paddingLeft: '0em',
                    paddingRight: '1em',
                    paddingTop: '1em',
                    paddingBottom: '1em',
                    listStyleType: 'none',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <span style={{ paddingRight: 10 }}>⭐</span>
                  {feature}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const wrapperColumnClass = classNames('col-lg-6 col-md-6 col-sm-12 text-center', {
      'center-col': !this.hasSoundcast(),
    });

    return (
      <FullContentWrapper>
        <FullContentSectionSignin className="row" background={Colors.window}>
          <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 center-col">
            <div className="row">
              <div className={wrapperColumnClass}>
                <SignInWindow className="row margin-lr-auto">
                  <div className="col-lg-6 col-sm-12 col-xs-12 center-col margin-two-top margin-two-bottom">
                    {this.renderImageUrlNode()}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-ten-bottom">
                    {this.renderFormBody()}
                  </div>
                </SignInWindow>
              </div>
              {this.renderSoundcastColumn()}
            </div>
          </div>
        </FullContentSectionSignin>
      </FullContentWrapper>
    );
  }
}

const FullContentSectionSignin = styled(FullContentSection)`
  background-image: url('/images/BG-Graphics@3x.png');
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #fff;
`;

const LogoImgWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`;

const SignInWindow = styled.div`
  max-width: 600px;
  min-width: 520px;

  @media (max-width: 767px) {
    min-width: initial;
  }
`;

const ClickHere = styled(Link)`
  color: ${Colors.mainOrange} !important;
  text-decoration: underline !important;
`;

const mapDispatchToProps = dispatch => bindActionCreators({ signinUser }, dispatch);
const mapStateToProps = () => ({});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppSignin));
